class BlogUsercaseImgSwiper extends HTMLElement {
  connectedCallback() {
    if (typeof Swiper === 'undefined') return;

    const sectionId = this.dataset.sectionId;
    if (!sectionId) return;

    const swiperEl = this.querySelector('.swiper');
    const slideCount = this.querySelectorAll('.swiper-slide').length;
    if (!swiperEl || slideCount === 0) return;

    const paginationEl = document.getElementById(`blog-usercase-img-swiper-pagination-${sectionId}`);
    const prevEl = document.getElementById(`blog-usercase-img-swiper-prev-${sectionId}`);
    const nextEl = document.getElementById(`blog-usercase-img-swiper-next-${sectionId}`);

    this.swiper = new Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false,
      watchOverflow: true,
      speed: 400,
      pagination: paginationEl
        ? {
            el: paginationEl,
            clickable: true
          }
        : false,
      navigation:
        prevEl && nextEl
          ? {
              prevEl: prevEl,
              nextEl: nextEl
            }
          : false,
      observer: true,
      observeParents: true
    });
  }

  disconnectedCallback() {
    if (this.swiper && typeof this.swiper.destroy === 'function') {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

if (!customElements.get('blog-usercase-img-swiper')) {
  customElements.define('blog-usercase-img-swiper', BlogUsercaseImgSwiper);
}
